import Immutable from 'immutable';
import { COLLECTION_SHAPE } from '../../../config/shapes';
import {
  FLAG_GETTING_BILLINGS,
  GET_BILLINGS,
  CLEAR_BILLINGS,
  FLAG_BILLING_ACTIVITY,
  GET_BILLING,
  CLEAR_BILLING,
  GET_BILLING_REPORT,
  FLAG_GETTING_BILLING_REPORT,
  CLEAR_BILLING_REPORT,
  FLAG_GETTING_BILLING_REPORT_DETAILS,
  GET_BILLING_REPORT_DETAILS,
  CLEAR_BILLING_REPORT_DETAILS,
  FLAG_BILLING_REPORT_DETAIL_ACTIVITY,
  GET_BILLING_REPORT_DETAIL,
  CLEAR_BILLING_REPORT_DETAIL,
  GET_BILLINGS_RETENTION,
  CLEAR_BILLINGS_RETENTION,
  FLAG_GETTING_BILLINGS_RETENTION,
} from '../../../actions/types/accounting';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map({
      page: Immutable.Map(COLLECTION_SHAPE),
      totalPEN: 0,
      totalUSD: 0,
      totalEUR: 0,
    }),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
  report: Immutable.Map({
    content: Immutable.Map(),
    loading: false,
  }),
  detail: Immutable.Map({
    all: Immutable.Map({
      content: Immutable.Map(COLLECTION_SHAPE),
      loading: false,
    }),
    current: Immutable.Map({
      content: Immutable.Map(),
      activity: Immutable.List(),
    }),
  }),
  retention: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_BILLINGS:
      return state.setIn(['all', 'loading'], payload);
    case GET_BILLINGS:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_BILLINGS:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_BILLING_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_BILLING:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case CLEAR_BILLING:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    case GET_BILLING_REPORT:
      return state.setIn(['report', 'content'], Immutable.Map(payload));
    case FLAG_GETTING_BILLING_REPORT:
      return state.setIn(['report', 'loading'], payload);
    case CLEAR_BILLING_REPORT:
      return state.setIn(['current'], INITIAL_STATE.getIn(['report']));
    case FLAG_GETTING_BILLING_REPORT_DETAILS:
      return state.setIn(['detail', 'all', 'loading'], payload);
    case GET_BILLING_REPORT_DETAILS:
      return state.setIn(['detail', 'all', 'content'], Immutable.Map(payload));
    case CLEAR_BILLING_REPORT_DETAILS:
      return state.setIn(
        ['detail', 'all', 'content'],
        INITIAL_STATE.getIn(['detail', 'all', 'content']),
      );
    case FLAG_BILLING_REPORT_DETAIL_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['detail', 'current', 'activity'],
          state.getIn(['detail', 'current', 'activity']).push(payload),
        );
      }

      return state.setIn(
        ['detail', 'current', 'activity'],
        state.getIn(['detail', 'current', 'activity']).pop(),
      );
    case GET_BILLING_REPORT_DETAIL:
      return state.setIn(
        ['detail', 'current', 'content'],
        Immutable.Map(payload),
      );
    case CLEAR_BILLING_REPORT_DETAIL:
      return state.setIn(
        ['detail', 'current'],
        INITIAL_STATE.getIn(['detail', 'current']),
      );
    case FLAG_GETTING_BILLINGS_RETENTION:
      return state.setIn(['retention', 'loading'], payload);
    case GET_BILLINGS_RETENTION:
      return state.setIn(['retention', 'content'], Immutable.Map(payload));
    case CLEAR_BILLINGS_RETENTION:
      return state.setIn(
        ['retention', 'content'],
        INITIAL_STATE.getIn(['retention', 'content']),
      );
    default:
      return state;
  }
};
